import { Loader2 } from 'lucide-react';
import { useUser } from '@/contexts/UserContext';
import { PlatformRoutes } from '@/app/platform/platformRoutes';
import { TenantRoutes } from '@/app/tenant/tenantRoutes';
import { CustomerRoutes } from '@/app/customer/customerRoutes';
import { useUserRoles } from '@/shared/hooks/userRoles';

/**
 * Selects platform, tenant, or customer route trees after session bootstrap.
 */
export function AppShellGate() {
  const { isLoading, isInitialized } = useUser();
  const { isPlatformUser, isCustomerUser } = useUserRoles();

  if (isLoading || !isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p>
            {!isInitialized ? 'Initializing...' : 'Loading...'}
          </p>
        </div>
      </div>
    );
  }

  if (isPlatformUser) return <PlatformRoutes />;
  if (isCustomerUser) return <CustomerRoutes />;
  // Tenant shell is the default for tenant users and unauthenticated guests (login/OTP/etc.).
  return <TenantRoutes />;
}
